import * as EmptyOrderFilesAction from "./EmptyOrderFilesAction";

export default function emptyOrderFilesReducer(state = {}, action) {
    switch (action.type) {
        case EmptyOrderFilesAction.REQUEST_EMPTY_ORDER_FILES_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    files: {
                        ...action.payload
                    }
                };
            }
        case EmptyOrderFilesAction.GET_EMPTY_ORDER_FILES_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    userFiles: {
                        ...action.payload.map(e => e.value)
                    }
                };
            }

        default:
            return state;
    }
}